<template>
  <section v-if="growthVitamins.length > 0">
    <v-row>
      <v-col>
        <div class="text-subtitle-1 font-weight-bold">
          {{ $translate('PRODUCT_PERSONAL_DISCOUNT_TITLE') }}
        </div>
        <div class="text-caption mb-4">
          {{ $translate('PRODUCT_PERSONAL_DISCOUNT_DESC') }}
        </div>

        <v-card
          v-for="(growthVitamin, growthVitaminIndex) in growthVitamins"
          :key="growthVitaminIndex"
          flat
          class="discount-card mb-2"
        >
          <v-row class="ma-0">
            <v-col cols="12" sm="3" align="center" align-self="center">
              <v-icon color="primary" class="mb-1">local_offer</v-icon>
              <div class="text-h4 font-weight-bold red--text">
                {{ getDiscountPercentageText(growthVitamin) }}
              </div>
            </v-col>

            <v-col cols="12" sm="9">
              <div class="text-subtitle-2">{{ growthVitamin.Name }}</div>
              <div class="text-caption text--secondary mb-2">
                {{ getGrowthVitaminExpireTimeText(growthVitamin) }}
              </div>
              <div
                class="text-caption"
                v-html="growthVitamin.Description"
              ></div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import utility from '@/shared/utility';

export default {
  name: 'ProductPersonalDiscount',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // Gowth vitamins of th type 'Percentage Discount' that contain this product
    growthVitamins() {
      const result = [];
      const allGrowthVitamins = this.$store.getters.getGrowthVitamins;
      if (
        allGrowthVitamins == null ||
        this.product == null ||
        this.product.Id == null
      ) {
        return result;
      }

      allGrowthVitamins.forEach(growthVitamin => {
        if (
          growthVitamin.DiscountInfo != null &&
          growthVitamin.DiscountInfo.Type === 'Percentage Discount' &&
          growthVitamin.DiscountInfo.Products != null
        ) {
          const index = growthVitamin.DiscountInfo.Products.findIndex(
            product => product.Id === this.product.Id
          );

          if (index >= 0) {
            result.push({ ...growthVitamin });
          }
        }
      });

      return result;
    }
  },
  data() {
    return {};
  },
  methods: {
    getDiscountPercentageText(growthVitamin) {
      const discountPercentage = parseInt(
        growthVitamin.DiscountInfo.DiscountPercentage,
        10
      );
      return `-${discountPercentage}%`;
    },
    getGrowthVitaminExpireTimeText(growthVitamin) {
      if (
        growthVitamin.ExpiryUnixTime == null ||
        growthVitamin.ExpiryUnixTime <= 0
      ) {
        return '';
      }

      const expireTimeStr = utility.unixTimeToDateTimeString(
        growthVitamin.ExpiryUnixTime
      );
      const result = utility.sprintf(
        this.$translate('GROWTH_VITAMIN_EXPIRE_TEXT'),
        expireTimeStr
      );

      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.discount-card {
  border: 2px solid var(--primary-color);
}
</style>
